import React, { useState } from 'react';
import { getAllTopics } from '../data/debateTopics';
import './TopicSelectionModal.css';

const TopicSelectionModal = ({ onTopicSelect, currentTopic, onTopicChange }) => {
  const [selectedTopic, setSelectedTopic] = useState(currentTopic);
  const topics = getAllTopics();

  const topicIcons = {
    anxiety_treatment: '😰',
    digital_vs_traditional: '💻',
    work_life_balance: '⚖️',
    depression_treatment: '🧠',
    child_psychology: '👶',
    sleep_disorders: '😴'
  };

  const topicCategories = {
    anxiety_treatment: 'Clinical',
    digital_vs_traditional: 'Technology',
    work_life_balance: 'Lifestyle',
    depression_treatment: 'Clinical',
    child_psychology: 'Pediatric',
    sleep_disorders: 'Sleep'
  };

  const handleTopicSelect = (topicId) => {
    setSelectedTopic(topicId);
    onTopicChange(topicId);
  };

  const handleStartConversation = () => {
    if (selectedTopic) {
      onTopicSelect(selectedTopic);
    }
  };

  const handleRandomTopic = () => {
    const randomIndex = Math.floor(Math.random() * topics.length);
    const randomTopic = topics[randomIndex];
    setSelectedTopic(randomTopic.id);
    onTopicChange(randomTopic.id);
  };

  const formatDuration = (duration) => {
    const minutes = Math.floor(duration / 60);
    return `${minutes} min`;
  };

  return (
    <div className="topic-selection-modal">
      <div className="modal-header">
        <h1>Choose a Debate Topic</h1>
        <p>Select a mental health topic to start the AI discussion.</p>
      </div>

      <div className="topics-grid">
        {topics.map((topic) => (
          <div
            key={topic.id}
            className={`topic-card ${selectedTopic === topic.id ? 'selected' : ''}`}
            onClick={() => handleTopicSelect(topic.id)}
          >
            <div className="topic-icon">
              {topicIcons[topic.id] || '💭'}
            </div>
            <div className="topic-content">
              <h3 className="topic-title">{topic.title}</h3>
              <p className="topic-description">{topic.description}</p>
              <div className="topic-tags">
                <span className="tag duration">{formatDuration(topic.duration)}</span>
                <span className="tag category">{topicCategories[topic.id] || 'General'}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="modal-actions">
        <button 
          className="start-button"
          onClick={handleStartConversation}
          disabled={!selectedTopic}
        >
          Start Conversation
        </button>
        <button 
          className="random-button"
          onClick={handleRandomTopic}
        >
          Random Topic
        </button>
      </div>
    </div>
  );
};

export default TopicSelectionModal;
